import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';

export interface LocationFooterLink {
  name: string;

  sales: LocationFooterLinkUrl;
  finance: LocationFooterLinkUrl;
  leasing: LocationFooterLinkUrl;
}

export interface LocationFooterLinkUrl {
  agentUrl?: string;
  agencyUrl?: string;
}

@Injectable({
  providedIn: 'root',
})
export class FooterApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public getLocationFooterLinks(): Observable<LocationFooterLink[]> {
    const url = this.rmaApiUrl('v1/Layout/FooterLinks');
    return this.httpClient.get<LocationFooterLink[]>(url);
  }
}
